// extracted by mini-css-extract-plugin
export default {"spinner":"eNRCx","error":"H4XDa","list":"IJt3Z","header":"Gp5Jb"};